<template>
    <div class="revenue-warp">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">挂号结算</el-menu-item>
            <el-menu-item index="2">执行业绩</el-menu-item>
            <el-menu-item index="3">药房业绩</el-menu-item>
            <el-menu-item index="4">接待业绩</el-menu-item>
        </el-menu>
        <div class="content-warp">
            <component :is="componentMap[activeIndex]"></component>
        </div>
    </div>
</template>
  
<script>

import registeredSettlement from './component/registeredSettlement.vue';
import executesettlement from './component/executesettlement.vue';
import PharmacyPerformance from './component/pharmacyPerformance.vue';
import receptionPerformance from './component/receptionPerformance.vue';
export default {
    // 定义引入的组件
    components: {
        registeredSettlement,
        executesettlement,
        PharmacyPerformance
    },
    props: {},
    data() {
        return {
            activeIndex: '1',
            componentMap: {
                '1': registeredSettlement,
                '2': executesettlement,
                '3': PharmacyPerformance,
                '4': receptionPerformance
            }
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() { },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 切换tab
         */
        handleSelect(val) {
            this.activeIndex = val
        },

    },
}
</script>
<style lang="less" scoped src="./index.less"></style>